import { render, staticRenderFns } from "./RoutingStaticShow.vue?vue&type=template&id=f61b2bda&"
import script from "./RoutingStaticShow.vue?vue&type=script&lang=js&"
export * from "./RoutingStaticShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports